module.exports = __webpack_public_path__ + "img/dragapult.35942670.jpg";